import ClientSchemaReduced from "./../Client/SchemaReduced";

const schema = {
  active: true,
  client: JSON.parse(JSON.stringify(ClientSchemaReduced)),
  id: "",
  line: "",
  personalSerial: "",
  serial: ""
};

export default schema;
